export enum ExceptionLanguagesType {
  ACT = "ACT",
  AET = "AET",
  AGT = "AGT",
  ART = "ART",
  AST = "AST",
  BET = "BET",
  BST = "BST",
  CAT = "CAT",
  CNT = "CNT",
  CST = "CST",
  CTT = "CTT",
  EAT = "EAT",
  ECT = "ECT",
  EST = "EST",
  HST = "HST",
  IET = "IET",
  IST = "IST",
  JST = "JST",
  MIT = "MIT",
  MST = "MST",
  NET = "NET",
  NST = "NST",
  PLT = "PLT",
  PNT = "PNT",
  PRT = "PRT",
  PST = "PST",
  SST = "SST",
  VST = "VST",
}
